module.exports = __webpack_public_path__ + "img/12.351b51cd.png";